<script setup lang="ts">
const props = defineProps<{
  number: number
  max: number
  activeNumber: number
  setNumber: (num: number) => void
}>()

const data = shallowReactive({
  userInput: '',
  isTextSelectionActive: false,
})

const input = useTemplateRef('input')
const isActive = computed(() => props.number === props.activeNumber)

function save(userInput: string) {
  data.isTextSelectionActive = false
  const number = Number.parseInt(userInput, 10)
  if (number !== props.activeNumber) props.setNumber(number)
}
function activeteItem() {
  if (isActive.value) activateInput()
  else save(props.number.toString())
}
function activateInput() {
  data.userInput = props.number.toString()
  data.isTextSelectionActive = true
  nextTick(() => helpers.getHTMLElement(input.value)?.focus())
}
const mainClass = computed(() => ({ edit: data.isTextSelectionActive && isActive.value, on: !data.isTextSelectionActive && isActive.value }))
</script>

<template>
  <component
    :is="isActive && data.isTextSelectionActive ? 'div' : 'button'"
    :type="isActive && data.isTextSelectionActive ? undefined : 'button'"
    :class="mainClass"
    @click.passive="activeteItem"
  >
    <input
      v-if="mainClass.edit"
      ref="input"
      v-model="data.userInput"
      type="text"
      class="input _fs12 _absolute _inset _txt_ctr"
      @keyup.passive.enter="save(data.userInput)"
      @blur.passive="save(data.userInput)"
    >
    <span v-else>{{ number }}</span>
  </component>
</template>
